"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoggerProvider = void 0;
var _loggerContext = require("./loggerContext");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Provides a logger instance to React components.
 *
 * @param props LoggerContextProviderProps
 */ var LoggerProvider = function(param) {
    var children = param.children, logger = param.logger;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_loggerContext.loggerContext.Provider, {
        value: logger,
        children: children
    });
};
exports.LoggerProvider = LoggerProvider; //# sourceMappingURL=LoggerProvider.js.map
